import React, { useState } from 'react';
import { Theme } from '../../../../Enums/Theme.enum';
import LinkButton from '../../../../Components/Button/LinkButton';
import CaseNoteModal from './CaseNoteModal';

interface Props {
	className?: string;
	note?: {
		id: string;
		text: string;
	};
	caseId: string;
	onSuccess?: () => void;
	firstUpper?: boolean;
}
const CaseNoteButton: React.FC<Props> = ({
	note,
	className,
	caseId,
	onSuccess,
	firstUpper = false,
}) => {
	const [isOpened, setIsOpened] = useState(false);

	const handleOnSuccess = () => {
		onSuccess && onSuccess();
		setIsOpened(false);
	};

	return (
		<>
			<LinkButton
				title={note ? 'base.shared.editNote' : 'base.shared.addNote'}
				theme={Theme.BLUE}
				onClick={() => setIsOpened(true)}
				className={className}
				firstUpper={firstUpper}
			/>
			<CaseNoteModal
				opened={isOpened}
				onClose={() => setIsOpened(false)}
				note={note}
				caseId={caseId}
				onSuccess={handleOnSuccess}
			/>
		</>
	);
};

export default CaseNoteButton;
